<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" @getOtherFormVal="getOtherFormVal" />
      <Settlement ref="settlement" @getOtherFormVal="getOtherFormVal" />
      <Apply ref="apply" @getOtherFormVal="getOtherFormVal" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Settlement from './settlement';
import Apply from './apply';
import SubBtnBox from 'components/subBtnBox';
import {
  servicerEdit,
  servicerDetail,
} from 'api/service';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Settlement,
    Apply,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/service/merchant/manage/edit',
      formComponents: ['baseForm', 'settlement', 'apply'],

      // 需要对比的参数
      compareParams: {
        loginAcct: '',
        serviceName: '',
        serviceType: '',
        companyAddress: '',
        realAuthType: '',
        linkman: '',
        identification: '',
        idenPictureFront: '',
        idenPictureBack: '',
        creditCode: '',
        state: '',

        balanceType: '',
        paymentMonth: '',
        paymentDays: '',
        quotaAmtStr: '',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        serviceUserId: this.$route.query.id,
        isEdit: 1,
      };
    },
  },
  methods: {
    detailApi: servicerDetail,
    editApi: servicerEdit,
    async getOtherFormVal ({ from, tar }) {
      const tarFormData = await this.$refs[tar].cacheData();
      this.$refs[from].receiveData(tar, tarFormData);
    },
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
